export function initAppcues() {
  if (window.Appcues) {
    try {
      window.Appcues.identify(undefined);
    } catch (error) {
      console.error(error);
    }
  }
}
